const SHOW_TIMESHEET_TEXT = "Show Reference Timesheet";
const HIDE_TIMESHEET_TEXT = "Hide Reference Timesheet";
const UPLOAD_TIMESHEET_TEXT = "Upload a Reference Timesheet";

export { SHOW_TIMESHEET_TEXT, HIDE_TIMESHEET_TEXT, UPLOAD_TIMESHEET_TEXT };
